module.exports = __webpack_public_path__ + "img/face12.711b1a92.jpg";